import { render, staticRenderFns } from "./AdminOnly.vue?vue&type=template&id=aa57c9f6&"
import script from "./AdminOnly.vue?vue&type=script&lang=js&"
export * from "./AdminOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports